import React from 'react'
import { InlineWidget } from "react-calendly";
import GreenProgressBar from '../../components/ProgressBars/GreenProgressBar/GreenProgressBar';

export default function Schedule() {
  return (
    <div className='schedule__container'>
    <div className='progress-bar__holder'>
    <GreenProgressBar progress="80" />
    </div>
    <div className='schedule__header-text'>
    <h1>Step 2: Schedule Your Call Now!</h1>
    </div>
    <div className='calendar-holder'>
      <InlineWidget
      styles={{
        height: '500px'
      }}
        url="https://calendly.com/rdevbob/high-value-client-schedule" />
      </div>
  </div>
  )
}
